import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IntercomService } from './intercom.service';

const INTERCOM_USER_HASH_HEADER_NAME = 'ttc-intercom-hash';

@Injectable()
export class IntercomUserHashInterceptor implements HttpInterceptor {
  constructor(private intercom: IntercomService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((response: HttpResponse<any>) => {
        const intercomUserHash =
          response.headers &&
          response.headers.get(INTERCOM_USER_HASH_HEADER_NAME);
        if (!intercomUserHash) {
          return;
        }
        this.intercom.setUserHash(intercomUserHash);
      }),
    );
  }
}
